import { ApiProperty } from "@nestjs/swagger";

export class ConsumtionReportRequest {
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    itemId?:number;
    @ApiProperty()
    consumedFromDate?:any;
    @ApiProperty()
    consumedToDate?:any;
    unitId?:number;
    @ApiProperty()
    createdDate?:Date;

    constructor(saleOrderId: number,itemId:number,consumedFromDate?:any,consumedToDate?:any,unitId?:number,createdDate?:Date,) {
        this.saleOrderId = saleOrderId;
        this.itemId=itemId;
        this.consumedFromDate=consumedFromDate;
        this.consumedToDate=consumedToDate;
        this.unitId=unitId;
        this.createdDate=createdDate;
    }

}